import * as actionType from './actionTypes';
import axios from 'axios';
import * as Constants from '../../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  drugFamilyDetail,
  rightTableData,
} from '../../DrugFamilyDetails/store/actions';
import {
  NDC_ALREADY_ADDED,
  NDC_FOR_UC_NOT,
  NDC_NOT_FOUND_STC,
} from '../../../../../SharedModules/Errors/constantMessageData';

export const selectionList = () => {
  return {
    type: actionType.SELECTION_TYPE_OPTIONS,
    payload: [
      { name: Constants.DRUG_FAMILY, value: Constants.DRUG_FAMILY_ID },
      { name: Constants.MANUFACTURER, value: Constants.MANUFACTURER_ID },
      {
        name: Constants.SPECIFIC_THERAPEUTIC_CLASS,
        value: Constants.SPECIFIC_THERAPEUTIC_CLASS_ID,
      },
      {
        name: Constants.SPECIFIC_DRUG,
        value: Constants.SPECIFIC_DRUG_ID,
      },
      {
        name: Constants.MARKET_BASKET,
        value: Constants.MARKET_BASKET_ID,
      },
      { name: Constants.CREATE_NEW, value: Constants.CREATE_NEW_ID },
    ],
  };
};

export const selectedType = (val) => {
  return {
    type: actionType.SELECTED_TYPE,
    payload: val,
  };
};

export const selectedSearchType = (val) => {
  return {
    type: actionType.SELECTED_SEARCH_TYPE,
    payload: val,
  };
};

export const popupFlag = (value) => {
  return {
    type: actionType.POPUP_FLAG,
    payload: value,
  };
};

export const errorMsg = (value) => {
  return {
    type: actionType.ERROR_MSGS,
    payload: value,
  };
};

export const ndcDataStore = (value) => {
  return {
    type: actionType.NDC_DATA,
    payload: value,
  };
};

export const ndcNameStore = (value) => {
  return {
    type: actionType.NDC_NAME,
    payload: value,
  };
};

export const navigateDetails = (value) => {
  return {
    type: actionType.NAVIGATE_DETAILS,
    payload: value,
  };
};

export const resetStoreDrugFamily = () => {
  return {
    type: actionType.RESET_DRUG_FAMILY_DATA,
  };
};

export const getAllDrugFamilies = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES)
    .then((response) => {
      dispatch({
        type: actionType.TABLE_DATA,
        payload: response.data.drugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.TABLE_DATA, payload: [] });
    });
};

export const getAllManufacturerDrugFamilies = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_MANUFACTURER_DRUG_FAMILIES)
    .then((response) => {
      dispatch({
        type: actionType.TABLE_DATA,
        payload: response.data.mfgVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.TABLE_DATA, payload: [] });
    });
};

export const getAllSpecificTheraClass = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_SPECIFIC_THERACLASS)
    .then((response) => {
      dispatch({
        type: actionType.TABLE_DATA,
        payload: response.data.drugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.TABLE_DATA, payload: [] });
    });
};

export const searchNDCs = (values, type, tableData) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEARCH_NDC_BY_CATEGORIES, values)
    .then((response) => {
      const { drugFamilyVOs } = response.data;
      if (type === Constants.Labeler) {
        dispatch({
          type: actionType.TABLE_DATA,
          payload: drugFamilyVOs,
        });
      } else if (type === Constants.Name) {
        if (drugFamilyVOs.length) {
          dispatch({
            type: actionType.SEARCH_LEFT_TABLE_DATA,
            payload: drugFamilyVOs,
          });
        } else {
          dispatch(errorMsg([NDC_FOR_UC_NOT]));
        }
      } else if (type === Constants.NDC) {
        if (drugFamilyVOs?.length) {
          if (tableData.some((obj) => obj.ndc === drugFamilyVOs[0].ndc)) {
            dispatch(errorMsg([NDC_ALREADY_ADDED]));
          } else {
            dispatch({
              type: actionType.RIGHT_TABLE_DATA,
              payload: [...tableData, ...drugFamilyVOs],
            });
          }
        } else if (drugFamilyVOs?.length === 0) {
          dispatch(errorMsg([NDC_NOT_FOUND_STC]));
        } else {
          dispatch(errorMsg([Constants.VALID_NDC_ERR]));
        }
      }
    })
    .catch((response) => {
      if (type === Constants.Labeler) {
        dispatch({ type: actionType.TABLE_DATA, payload: [] });
      } else if (type === Constants.Name) {
        dispatch({
          type: actionType.SEARCH_LEFT_TABLE_DATA,
          payload: [],
        });
        dispatch(errorMsg([Constants.VALID_NDC_MSG]));
      } else if (type === Constants.NDC) {
        dispatch(errorMsg([Constants.VALID_NDC_ERR]));
      }
    });
};

export const getAllMarketBasket = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEARCH_BY_MARKET_BASKET)
    .then((response) => {
      dispatch({
        type: actionType.TABLE_DATA,
        payload: response.data.marketBasketDrugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.TABLE_DATA, payload: [] });
    });
};

export const getPopupMarketBasket = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_MARKET_BASKET, values)
    .then((response) => {
      dispatch({
        type: actionType.POPUP_TABLE_DATA,
        payload: response.data.marketBasketDrugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.POPUP_TABLE_DATA, payload: [] });
    });
};

export const getPopupManufacturer = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_MFGID, values)
    .then((response) => {
      dispatch({
        type: actionType.POPUP_TABLE_DATA,
        payload: response.data.mfgDrugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.POPUP_TABLE_DATA, payload: [] });
    });
};

export const getPopupLabeler = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_LABELER, values)
    .then((response) => {
      dispatch({
        type: actionType.SEARCH_LEFT_TABLE_DATA,
        payload: response.data.drugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.SEARCH_LEFT_TABLE_DATA, payload: [] });
      dispatch(errorMsg([Constants.VALID_NDC_MSG]));
    });
};

export const getPopupSpecificTherapeuticClass = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_STC, values)
    .then((response) => {
      dispatch({
        type: actionType.POPUP_TABLE_DATA,
        payload: response.data.drugFamilyVOs,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.POPUP_TABLE_DATA, payload: [] });
    });
};

export const getDrugFamilyDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_SEQUNUM, values)
    .then((response) => {
      // dispatch(drugFamilyDetail(response.data));
      dispatch(
        drugFamilyDetail(response.data?.drugFamilyWrapperVO?.drugFamilyVO)
      );
      dispatch(
        rightTableData(response.data?.drugFamilyWrapperVO?.drugFamilyDrugVO)
      );
      dispatch({
        type: actionType.DRUG_FAMILY_DAETAILS,
        payload: response.data,
      });
    })
    .catch(() => {
      dispatch({ type: actionType.DRUG_FAMILY_DAETAILS, payload: {} });
      errorMsg([Constants.SELECTION_NOT_MATCH]);
    });
};

export const getDrugFamilyDetailsByNDC = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_NDC, values)
    .then((response) => {
      if (response.data?.drugFamilyVOs.length)
        dispatch(drugFamilyDetail(response.data?.drugFamilyVOs?.[0]));
      dispatch({
        type: actionType.DRUG_FAMILY_DAETAILS,
        payload: response.data,
      });
    })
    .catch((response) => {
      dispatch({ type: actionType.DRUG_FAMILY_DAETAILS, payload: {} });
      errorMsg([Constants.SELECTION_NOT_MATCH]);
    });
};
// clear drug family screen data
export const clearReduxDrugFamilyScreen = () => (dispatch) => {
  dispatch({ type: actionType.TABLE_DATA, payload: [] });
  dispatch(errorMsg([]));
  dispatch({ type: actionType.POPUP_TABLE_DATA, payload: [] });
  dispatch({ type: actionType.SEARCH_LEFT_TABLE_DATA, payload: [] });
  dispatch({ type: actionType.RIGHT_TABLE_DATA, payload: [] });
};
